import React, { useEffect } from "react";
import { ScrollTrigger } from "../animations/gsap.config";
import AboutHero from "../components/about/AboutHero";
import OurStory from "../components/about/OurStory";
import CoreValues from "../components/about/CoreValues";
import TeamOverview from "../components/about/TeamOverview";
import SEO from "../components/SEO";
import { useApp } from "../context/AppContext";

const About = () => {
  const { companyinfo } = useApp();
  /* Refresh ScrollTrigger after all components mount */
  useEffect(() => {
    const timer = setTimeout(() => {
      ScrollTrigger.refresh();
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <SEO
        title="About Us | Catalyst for Positive Change"
        description="Learn about Agora Consulting's mission to bridge the gap between international best practices and local Ethiopian realities, founded by Tewelde Gebremariam."
        keywords={[
          "Tewelde Gebremariam",
          "Agora Story",
          "Socio-economic development",
          "Ethiopia local context",
          "Sustainable Development Goals",
        ]}
        url="https://agoraconsulting-et.com/about"
        image={`${companyinfo?.logo}`}
      />
      <main className="bg-white">
        <AboutHero />
        <OurStory />
        <CoreValues />
        <TeamOverview />
      </main>
    </>
  );
};

export default About;
